import PrescriptionCreate from './PrescriptionCreate'

export * from './PrescriptionCreate'

export default PrescriptionCreate
